/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Nested payment data from VGS. Send snake_case property names.
 * All properties optional.
 * 
 * @export
 * @interface ApplePayPaymentData
 */
export interface ApplePayPaymentData {
    /**
     * Tokenized PAN (alias for top-level).
     * @type {string}
     * @memberof ApplePayPaymentData
     */
    cardNumberTokenized?: string;
    /**
     * Tokenized CVC (alias for top-level).
     * @type {string}
     * @memberof ApplePayPaymentData
     */
    cardCvcTokenized?: string;
}

/**
 * Check if a given object implements the ApplePayPaymentData interface.
 */
export function instanceOfApplePayPaymentData(value: object): value is ApplePayPaymentData {
    return true;
}

export function ApplePayPaymentDataFromJSON(json: any): ApplePayPaymentData {
    return ApplePayPaymentDataFromJSONTyped(json, false);
}

export function ApplePayPaymentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplePayPaymentData {
    if (json == null) {
        return json;
    }
    return {
        
        'cardNumberTokenized': json['card_number_tokenized'] == null ? undefined : json['card_number_tokenized'],
        'cardCvcTokenized': json['card_cvc_tokenized'] == null ? undefined : json['card_cvc_tokenized'],
    };
}

export function ApplePayPaymentDataToJSON(json: any): ApplePayPaymentData {
    return ApplePayPaymentDataToJSONTyped(json, false);
}

export function ApplePayPaymentDataToJSONTyped(value?: ApplePayPaymentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_number_tokenized': value['cardNumberTokenized'],
        'card_cvc_tokenized': value['cardCvcTokenized'],
    };
}

